import "./../../bindings/bao-searcher";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import "./../../services/bao-router";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import * as moment from "moment";
class WorkplacePlanningCopyDialog {
    Bao = Bao;
    FromDate: KnockoutObservable<string> = ko.observable();
    ToDate: KnockoutObservable<string> = ko.observable();
    OverwriteTarget: KnockoutObservable<boolean> = ko.observable(false);
    ShiftGroupName: KnockoutObservable<string> = ko.observable();
    ShiftGroupId: KnockoutObservable<string> = ko.observable();
    SourceDate: KnockoutObservable<string> = ko.observable();
    ToSourceDate: KnockoutObservable<string> = ko.observable();
    ShiftbookIdsStringifiedForCustomFilter: KnockoutObservable<string> = ko.observable("");
    DateTimeBoxSourceDate: Bindings.baoDateTimeBox = {
        value: this.FromDate,
        mode: 'date',
        culture: Bao.Session.Language.Symbol()
    };
    DateTimeBoxFromDate: Bindings.baoDateTimeBox = {
        value: this.FromDate,
        mode: 'date',
        culture: Bao.Session.Language.Symbol()
    };
    DateTimeBoxToDate: Bindings.baoDateTimeBox = {
        value: this.ToDate,
        mode: 'date',
        culture: Bao.Session.Language.Symbol()
    };
    DatePickerSourceDate: Bindings.baoDateTimePicker = {
        mode: 'date'
    };
    DatePickerFromDate: Bindings.baoDateTimePicker = {
        mode: 'date'
    };
    DatePickerToDate: Bindings.baoDateTimePicker = {
        mode: 'date'
    };

    SearcherShiftGroup: Bindings.baoSearcher;

    constructor(shiftGroupId: string, shiftGroupName: string, sourceDate: string, toSourceDate: string, shiftbookIdsStringifiedForCustomFilter: string) {
        // 'copy' date
        this.SourceDate(sourceDate);
        // 'TO' date
        this.ToSourceDate(toSourceDate);    
        this.FromDate(moment(this.SourceDate(), Bao.Utils.DateTimeFormat).add(1, 'day').format(Bao.Utils.DateTimeFormat));
        this.ToDate(moment(this.ToSourceDate(), Bao.Utils.DateTimeFormat).format(Bao.Utils.DateTimeFormat));
        this.ShiftGroupName = ko.observable(shiftGroupName);
        this.ShiftGroupId = ko.observable(shiftGroupId);  
        this.ShiftbookIdsStringifiedForCustomFilter(shiftbookIdsStringifiedForCustomFilter);
        
        this.SearcherShiftGroup = {
            ObjectId: this.ShiftGroupId,
            ObjectValue: 'Name',
            SearchType: 'ShiftGroup',
            AutoComplete: true,
            AutoSearch: true,
            CustomFilter: { ShiftbookIds: this.ShiftbookIdsStringifiedForCustomFilter }
        };
    }
}
export default WorkplacePlanningCopyDialog;